const initialState = {
    apks: [],
    channels: [],
    device: {},
    deviceGroups: [],
    deviceTypes: [],
    fetchingData: true,
    formConfig: 'DefaultUpdateForm',
    formErrors: {
        general: null,
        api_url: null,
        apk_version: null,
        background_colour: null,
        cec_enabled: null,
        device_owner: null,
        file_auth: null,
        file_url: null,
        id: null,
        layer_enabled: null,
        layer_extra: null,
        manufacturer: null,
        migrated_at: null,
        model: null,
        ntp_url: null,
        screen_rotation: null,
        selected_channel: null,
        sku: null,
        socket_url: null,
        store_code: null,
        store_location: null,
        store_sync: null,
        sync_delay: null,
        sync_offset: null,
        sync_timeout: null,
        sync_url: null,
        volume: null,
        working_close: null,
        working_open: null,
    },
    isOpenAdvancedOptions: false,
    isOpenServerOptions: false,
    storeLocations: [],
}

export default initialState
